module.exports = __webpack_public_path__ + "img/trash-can.20d3e9a1.svg";